module.exports = __webpack_public_path__ + "a9b009caefb47431ee7d94d1fee0df09.svg";